<template>
    <el-dialog :visible.sync="visible" title="学籍信息录入二维码" :close-on-click-modal="false" :close-on-press-escape="false"
               :destroy-on-close="true">
        <el-card shadow="never" class="aui-card--fill">
            <el-form :model="dataForm"  ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
            <el-form-item label="是否开启信息录入通道" label-width="160px"  prop="isStudentImg" size="mini">
                <el-radio-group v-model="dataForm.isStudentImg" style="width: 200px" @change="dataFormSubmitHandle">
                    <el-radio :label="0" >否</el-radio>
                    <el-radio :label="1">是</el-radio>
                </el-radio-group>
            </el-form-item>
                <el-from-item>
                    <el-button  type="primary" @click="download()">
                        信息录入通道二维码下载
                    </el-button>
                </el-from-item>
            </el-form>

        </el-card>
        <div id="1" style="display: none">
            <vue-qr :correctLevel="3"
                    :logoScale="0.3"
                    :text="qrCodeText"
                    :size="256"
                    :margin="10"
                    :dotScale="1"
                    colorDark="#2c5ea8"
                    style="margin: 10px">
            </vue-qr>
        </div>
        <canvas id="box" style="display: none;background: #FFFFFF;" width="270px"
                height="300px"></canvas>
    </el-dialog>
</template>
<script>
import debounce from 'lodash/debounce'
import VueQr from 'vue-qr'
export default {
  data () {
    return {
      visible: false,
      studentId: '',
      url: '',
      qrCodeText: '',
      dataForm: {
        isStudentImg: '',
        schoolId: ''
      }
    }
  },
  components: {
    VueQr
  },
  methods: {
    init () {
      this.visible = true
      this.getInfo()
    },
    studentImgHandle () {
      this.$http.get('/student/studentStatusInfo/getImg').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.url = res.data
        console.log(this.url)
      })
    },
    getInfo () {
      this.$http.get(`/StudentInfoImg/getValue?schoolId=${this.dataForm.schoolId}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        console.log(res.data)
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      })
    },
    download () {
      // this.$http.get(`organization/organization/getOrganizationByAppId/${value}`).then(({ data: res }) => {
      //    this.logoSrc = res.data.logoUrl
      this.qrCodeText = 'http://wap.bjpj.chst.club/extra/info_complete/register.html'
      console.log(this.qrCodeText)
      const that = this
      setTimeout(function () {
        that.printCanvas(1, 'single')
      }, 500)
      //   }).catch((e) => {
      //  return this.$message.error(e.msg)
      //      })
    },
    printCanvas (id, type) { // id表示对应的二维码标签的id   type表示画布的类型
      const c = document.getElementById('box') // 获取canvas画布 画布大小和canvas大小一致
      // let picName = '测试图片' + id
      const ctx = c.getContext('2d')
      c.height = c.height // 清空画布，重新绘制
      const imageData = ctx.getImageData(0, 0, c.width, c.height)
      for (let i = 0; i < imageData.data.length; i += 4) {
        if (imageData.data[i + 3] === 0) {
          imageData.data[i] = 255
          imageData.data[i + 1] = 255
          imageData.data[i + 2] = 255
          imageData.data[i + 3] = 255
        }
      }
      ctx.putImageData(imageData, 0, 0)
      ctx.fillStyle = '#2c5ea8'
      let div = null//    设置div变量
      // 判断类型：single 单张  batch  批量
      if (type !== 'single') { //  获取到需要绘制到canvas的div即二维码div
        div = document.getElementById('batch' + id)
      } else { //  获取到需要绘制到canvas的div即二维码div
        div = document.getElementById(id)
      }
      const img = div.getElementsByTagName('img')[0] //  获取二维码
      ctx.drawImage(img, 7, 7, 256, 256) // 参数依次为：绘制图片， 左，上，宽，高
      ctx.font = '20px bold 微软雅黑 ' // 设置字体大小  这里文字的加粗一直无效，至今没搞清楚原因 有能解决的朋友可以私聊
      // 多画几次，让字体加粗  解决文字无法加粗问题
      for (let i = 0; i < 10; i++) {
        ctx.fillText('学籍信息收集', 76, 285) // 使用偏移量加粗字体
      }
      const dataUrl = c.toDataURL() // 获取返回的base64的信息
      // this.dataUrls.push({ picData: dataUrl, fileName: picName }) // 把数据存进数组里面
      // 如果类型是单张（single）则下载合成好的图片
      if (type === 'single') {
        const link = document.createElement('a')
        link.download = '学籍信息收集.jpg'
        link.href = dataUrl
        link.click()
      }
    },
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http.post(`/StudentInfoImg?schoolId=${this.dataForm.schoolId}`, this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            if (res.code === 10050) {
              this.schoolVisible = true
              this.getSchoolList()
            }
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
            }
          })
        }).catch((err) => {
          console.log(err)
        })
      })
    }, 1000, { leading: true, trailing: false })
  },
  mounted () {
    this.studentId = this.$route.params.id
  }
}
</script>
<style scoped>
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
    }

    .avatar {
        width: 100px;
        height: 100px;
        display: block;
    }
</style>
